<div class="col-md-12">
  <br>
  <h4>Notices</h4>

  <mat-tab-group>
    <mat-tab label="Property">
      <ng-container *ngTemplateOutlet="noticeList; context: { notices: propertyNotices(), loading: loadingProperty(), empty: 'No property notices.' }"></ng-container>
    </mat-tab>

    <mat-tab [label]="unitNumber() ? 'Unit ' + unitNumber() : 'My Unit'">
      @if (unitNumber()) {
        <ng-container *ngTemplateOutlet="noticeList; context: { notices: unitNotices(), loading: loadingUnit(), empty: 'No notices for your unit.' }"></ng-container>
      } @else {
        <p class="mt-3 text-muted">No unit number found on your profile.</p>
      }
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #noticeList let-notices="notices" let-loading="loading" let-empty="empty">
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    @for (notice of notices; track notice.id ?? $index) {
      <div class="card notice-card mt-3">
        <div class="card-body">
          <h5 class="card-title">{{ notice.shortDescription }}</h5>
          @if (notice.dateVisible) {
            <h6 class="card-subtitle mb-2 text-muted">{{ notice.dateVisible | date: 'medium' }}</h6>
          }
          <p class="card-text notice-message">{{ notice.longDescription }}</p>
        </div>
      </div>
    } @empty {
      <p class="mt-3 text-muted">{{ empty }}</p>
    }
  }
</ng-template>
